<template>
  <div class="contianer">
    <h1>(404) Ups! Página no encontrada</h1>
  </div>
</template>

<script>
export default {
    name: '404',
    components: {
    },
    data() {
        return {}
    }
}
</script>